import React, { useState, useEffect } from "react";
import { Icon, Image } from "semantic-ui-react";
import { ENV, buildStorageUrl } from "../../../../../../utils";
import "../TemplateManager.scss";

export const Smu07 = React.memo((props) => {
  const { slideId, activeSession } = props;
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState("");

  /**
   * Synchronizes component state with the content of the currently selected slide in Smu07.js.
   *
   * This `useEffect` hook is executed whenever the `slideId` changes. It searches through the `activeSession.slides`
   * array to find a slide that matches the `slideId`. If such a slide is found and it contains content, the hook
   * updates the component's state with the slide's title, content, and image URL.
   *
   * Specifically, it performs the following actions:
   * - Sets the `title` state with the title from the slide's content.
   * - Sets the `content` state with the textual content from the slide.
   * - Sets the `image` state with the URL of the image from the slide's content.
   *
   * This ensures that the component accurately reflects the content of the currently selected slide, allowing for
   * effective editing and previewing within an active session. It provides a detailed view of the slide's content,
   * focusing on the title, textual content, and image to enhance user engagement and content interaction.
   *
   * @dependency slideId - The ID of the current slide, changes to which trigger the hook.
   */
  useEffect(() => {
    const slide = activeSession.slides.find((slide) => slide._id === slideId);
    if (slide && slide.content) {
      setTitle(slide.content.title);
      setContent(slide.content.content);
      setImage(slide.content.image);
    }
  }, [slideId]);

  return (
    <div className="row">
      <h3 className="show-slide__title">
        <Icon name="bookmark" />
        {title}
      </h3>
      <div className="show-slide__body">
        <div className="row" dangerouslySetInnerHTML={{ __html: content }} />
        <Image bordered rounded fluid src={buildStorageUrl(image)} />
      </div>
    </div>
  );
});
